import React from 'react';
import WeatherImpactGrid from './WeatherImpactGrid';

export default function WeatherImpact() {
  return <WeatherImpactGrid />;
}
